import ColorIdentifier from '@components/ui/ColorIdentifier'
import config from '@config/seo_meta.json'
import Image from 'next/legacy/image'
import Link from 'next/link'

interface Props {
  slice: any
}
const Banner = ({ slice }: Props) => {
  const colorName = slice?.primary?.Color
  const colorHexCode = slice?.primary?.ColorHexCode
  const color = { colorName, colorHexCode }
  const leftImage = slice?.primary?.LeftImage
  const rightImage = slice?.primary?.RightImage
  const bannerText = slice?.primary?.BannerText
  const linkTitle = slice?.primary?.LinkTitle
  const linkUrl = slice?.primary?.LinkUrl
  const colorUrl = slice?.primary?.colorUrl
  return (
    <section>
      <div className="relative mx-auto -mt-[3.55rem] w-full lg:-mt-16">
        <div className="flex flex-col items-center justify-center lg:flex-row ">
          <div className="relative w-full text-img lg:w-1/2">
            {leftImage?.url && (
              <Image
                layout="responsive"
                height={810}
                width={720}
                src={leftImage.url}
                alt={leftImage?.alt || config.openGraph.images[0].alt}
                priority
              />
            )}
            <Link href={!colorUrl ? '/' : colorUrl} legacyBehavior>
              <a>
                <ColorIdentifier
                  className="absolute bottom-4 left-4 block lg:hidden"
                  color={color}
                />
              </a>
            </Link>
          </div>
          <div className="hidden w-1/2 text-img lg:block">
            {rightImage?.url && (
              <Image
                layout="responsive"
                height={810}
                width={720}
                src={rightImage.url}
                alt={rightImage?.alt || config.openGraph.images[0].alt}
                priority
              />
            )}
          </div>
          <div className="relative block h-64.5 w-full text-img lg:hidden">
            {rightImage?.url && (
              <Image
                objectFit="cover"
                layout="fill"
                src={rightImage.url}
                alt={rightImage?.alt || config.openGraph.images[0].alt}
              />
            )}
            {bannerText && (
              <div className="heading-mobile-4 absolute left-4 bottom-17 right-4 max-w-168 text-primary">
                {bannerText}
              </div>
            )}
            {linkUrl && (
              <Link href={linkUrl} legacyBehavior>
                <a className="body-1 text-decoration-line: absolute bottom-7 left-4 text-primary underline lg:bottom-16 lg:left-16">
                  {linkTitle}
                </a>
              </Link>
            )}
          </div>
          <div className="absolute bottom-0 hidden w-full pb-14 lg:block">
            <div className="wrapper flex items-end">
              <div className="w-1/2">
                <Link href={!colorUrl ? '/' : colorUrl} legacyBehavior>
                  <a>
                    <ColorIdentifier color={color} />
                  </a>
                </Link>
              </div>
              <div className="w-1/2 pl-14">
                <h1 className="heading-4 mb-6 text-primary">{bannerText}</h1>
                <Link href={linkUrl} legacyBehavior>
                  <a className="body-1 text-decoration-line: text-primary underline">
                    {linkTitle}
                  </a>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .circle:hover {
            position: absolute;
            bottom: 4rem;
            left: 4rem;
          }
        `}
      </style>
    </section>
  )
}

export default Banner
